
export interface Employee {
    id: string;
    name: string;
    username: string;
    role: "Super Admin" | "Super Super Admin" | "Viewer";
    isActive: boolean;
  }
  
  export interface FormState {
    name: string;
    username: string;
    password: string;
    role: "Super Admin" | "Super Super Admin" | "Viewer";
  }
  
  export  const EMPTY_FORM: FormState = { name: "", username: "", password: "", role: "Super Admin" };
  export const ROLE_OPTIONS: Array<"Super Admin" | "Super Super Admin" | "Viewer"> = ["Super Admin", "Super Super Admin", "Viewer"];

  export const getInitials = (name: string) =>
    name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "??";
  
  export const getApiError = (e: any): string =>
    e?.response?.data?.error?.message ||
    e?.response?.data?.message ||
    e?.message ||
    "An unexpected error occurred";